import React, { Component } from 'react';
import { Statistic, notification, Row, Col, Modal, Table } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import dashboardService from 'services/dashboard.service';
import { formatMoney, formatDateForClient, formatDateForServer } from 'helpers/utils';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import { NavLink } from 'react-router-dom';
import dayjs from 'dayjs';

class CurrentAccountBalance extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      currentMerch: context?.selectedMerch,
      startDate: formatDateForClient(dayjs().subtract(2, 'years')),
      endDate: formatDateForClient(),
      selectedBranch: '0',
      modalVisible: false,
      loading: false,
      partialColumns: [
        {
          title: 'Şube ID / Şube Adı',
          dataIndex: 'BranchId',
          key: 'BranchId',
          render: (text, row) => (
            <span>
              {row.BranchId} - {row.BranchName}
            </span>
          ),
        },
        {
          title: 'Terminal Numarası / Cihaz Sicil Numarası',
          dataIndex: 'BranchName',
          key: 'BranchName',
        },
        {
          title: 'İşlem Numarası / İşlem Tipi',
          dataIndex: 'ActionNumber',
          key: 'ActionNumber',
        },
        {
          title: 'Tutar / İşlem Tarihi',
          dataIndex: 'TotalAmount',
          key: 'TotalAmount',
          render: (text) => <span>{`${formatMoney(text)} TL`}</span>,
        },
        {
          title: 'Gün Sonu ID / Gün Sonu Tarihi',
          dataIndex: 'EODID',
          key: 'EODID',
        },
      ],
    };
  }

  componentDidMount() {
    this.getInvoices();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.getInvoices();
    }
  }

  getInvoices = async () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      const { currentMerch } = this.state;
      if (currentMerch?.number) {
        try {
          const { payload } = await dashboardService.getDashboardCurrentAccountReports(
            currentMerch?.number,
          );
          this.setState({ data: payload, loading: false });
          this.setState({ loading: false });
        } catch (error) {
          notification.error({
            message: 'İşlem Başarısız!',
            description: error,
          });
          this.setState({ loading: false });
        }
      }
    });
  };

  getPartialInvoices = (currentPage) => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, endDate, startDate, selectedBranch } = this.state;
        if (currentMerch?.number) {
          const { payload } = await reportService.getEodReportsByMerch(
            currentMerch?.number,
            formatDateForServer(startDate),
            formatDateForServer(endDate),
            selectedBranch,
            currentPage,
          );
          this.setState({ loading: false, partialReports: payload, modalVisible: true });
        }
      } catch (error) {
        this.setState({ loading: false, partialReports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  handleCloseForm = () => {
    this.setState({ modalVisible: false, partialReports: [] });
  };

  render() {
    const { loading, data, partialColumns, partialReports, modalVisible } = this.state;

    return (
      <>
        <PageContainer
          title="Cari Hesap Bakiyesi"
          footer={
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <NavLink to="/raporlar/cari-hesap-raporu">
                <span style={{ color: 'blue', fontSize: 15 }}>Cari Hesap Raporu </span>
              </NavLink>
            </div>
          }
        >
          <Row gutter={[0, 0]}>
            <Col span={12}>
              <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <Statistic
                  loading={loading}
                  title="Bakiye Tutarı"
                  value={formatMoney(data.Bakiye)}
                  valueStyle={{ fontSize: '35px', color: 'blue' }}
                />
                <span style={{ fontSize: '25px', color: 'blue', align: 'bottom' }}>
                  {data.Bakiye > 0 ? '(B)' : '(A)'}{' '}
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={[0, 31]}>
            <Col span={18}>
              <Statistic
                loading={loading}
                title="Son Bakiye Tarihi"
                value={dayjs(data.Date).format('DD.MM.YYYY')}
                valueStyle={{ fontSize: '13px' }}
              />
            </Col>
          </Row>
        </PageContainer>

        <Modal
          width={1400}
          open={modalVisible}
          footer={false}
          title="Ödeme Detayları"
          onCancel={this.handleCloseForm}
          destroyOnClose
        >
          <Table
            loading={loading}
            dataSource={partialReports}
            columns={partialColumns}
            style={{ width: '100%', height: '100%' }}
            pagination
            rowKey={(record, index) => index}
            onChange={(page) => this.getPartialInvoices(page.current)}
          />
        </Modal>
      </>
    );
  }
}

CurrentAccountBalance.contextType = AuthContext;
export default CurrentAccountBalance;
